import axios from 'axios';

// Backend API base URL
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

// Define API service
const apiService = {
  // Get API documentation
  getApiDocs() {
    return axios.get(`${API_URL}/api`);
  },

  // Generic GET request
  get(url, config = {}) {
    return axios.get(`${API_URL}${url}`, config);
  },

  // Generic POST request
  post(url, data, config = {}) {
    return axios.post(`${API_URL}${url}`, data, config);
  },

  // Generic PUT request
  put(url, data, config = {}) {
    return axios.put(`${API_URL}${url}`, data, config);
  },

  // Generic DELETE request
  delete(url, config = {}) {
    return axios.delete(`${API_URL}${url}`, config);
  },

  // Health check
  healthCheck() {
    return axios.get(`${API_URL}/api/health`);
  },

  // Swagger documentation URLs for different microservices
  getSwaggerUrl(service = null) {
    if (!service) {
      return `${API_URL}/static/swagger_ui.html`;
    }
    
    // Capitalize the first letter of the service name for the URL parameter
    const serviceName = service.charAt(0).toUpperCase() + service.slice(1);
    return `${API_URL}/static/swagger_ui.html?urls.primaryName=${serviceName}`;
  },

  // List all available microservices
  async getMicroservices() {
    try {
      const response = await axios.get(`${API_URL}/api/services`);
      return response.data;
    } catch (error) {
      console.error('Error fetching microservices:', error);
      // Fallback to hardcoded services if API fails
      return {
        success: true,
        services: [
          { name: 'Authentication', path: 'auth', description: 'User authentication and registration' },
          { name: 'Properties', path: 'properties', description: 'Property management and geospatial data' },
          { name: 'Users', path: 'users', description: 'User management and profiles' },
          { name: 'Data', path: 'data', description: 'Data import, export, and style configurations' },
          { name: 'Settings', path: 'settings', description: 'User settings and preferences' }
        ]
      };
    }
  }
};

export default apiService;